// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-image[data-v-4b214fb0] {\n  width: 58px !important;\n  height: 58px !important;\n}\n.el-image[data-v-4b214fb0] .image-solt {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  border: 2px dashed #E4E7ED;\n}\n.el-image[data-v-4b214fb0] .image-solt i {\n  font-size: 26px;\n  color: #C0C4CC;\n  transform: translateY(50%);\n}\n", ""]);
// Exports
module.exports = exports;
